import React, { useEffect, useState } from "react";
import { ArrowRight, Check } from "react-feather";
import Input from "../input";
let f = "";
let t = "";

export default function ValentinesCards({ templates }) {
  const [template, setTemplate] = useState(templates[0]._id);
  const [from, setFrom] = useState(f);
  const [to, setTo] = useState(t);

  async function createCard(e) {
    e.preventDefault();

    const res = await fetch(`/api/valentines`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ template, from, to }),
    });
    f = from;
    t = to;

    const json = await res.json();

    if (json && json.id) {
      window.location.href = `/kartki-walentynkowe/${json.id}`;
    }
  }

  return (
    <div>
      <div className="valentines_cards">
        <div className="valentines_hero">
          <h1>
            Generator kartek walentynkowych <b>❤️</b> memy
          </h1>
          <p>
            Stwórz spersonalizowaną kartkę walentynkową i wywołaj uśmiech na twarzy osoby, na której Ci zależy <b>☺️</b>
          </p>
          <p className="small">Zaznacz format, który najbardziej Ci się spodobał. Na dole wpisz od kogo i dla kogo jest ta walentynka - generator naniesie imiona na kartkę.</p>
        </div>
        <div className="templates">
          {templates
            .map((t) => t._id)
            .map((t, i) => [
              <div key={t} onClick={() => setTemplate(t)} className={["template"].join(" ")}>
                <img src={`https://memy.memsekcja.pl/love/${t}.jpeg`} alt={t} />
                <div className={[template === t ? "template_selected" : ""].join(" ")}>
                  <div className="template_check">{template === t ? <Check size={18} /> : null}</div>
                </div>
              </div>,
              (i + 1) % 6 === 0 ? <Ad key={t + "-ad"} key={t + "-ad"} /> : null,
            ])}
        </div>
      </div>

      <div className="_generate_form">
        <form onSubmit={createCard} className="generate_form">
          <span>Od:</span>
          <Input
            // label="Od:"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
            placeholder="Ode mnie"
            maxlength={15}
          />
          <span>Dla:</span>
          <Input
            // label="Dla:"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            placeholder="Dla Ciebie"
            maxlength={15}
          />
          <div>
            <button className="generate_btn">
              <span>Wygeneruj walentynkę</span>
              <ArrowRight />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Ad() {
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }, []);

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 900,
      }}
    >
      <ins
        className="adsbygoogle"
        data-ad-client="ca-pub-3051535093810095"
        data-ad-slot="7812208501"
        style={{ display: "block", minWidth: 300, maxHeight: 150, width: "100%", height: 150 }}
      />
    </div>
  );
}
